import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSankeyAxis: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSankeyAxis"><Path d="M3.5 3.5V20.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M5.5 6.5C11.1422 6.5 13.8578 15.5 19.5 15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M19.5 5.5C13.8578 5.5 11.1422 12.5 5.5 12.5" stroke="currentColor" strokeLinecap="square"/><Path d="M19.5 10.5C13.8578 10.5 11.1422 17.5 5.5 17.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSankeyAxis;
